import { action, observable } from 'mobx'
import { validationContext } from 'validx'
import {
  type ErrorDescriptor,
  receiveErrors,
} from '@/features/legends/editor/analyzer-errors'
import { ConfigEditorViewModelBase } from './ConfigEditorViewModelBase'
import type { MessageConfig } from './legend-options'

/**
 * The welcome message sent once the job is picked up.
 */
export class MessageConfigEditorViewModel extends ConfigEditorViewModelBase<MessageConfig> {
  @observable accessor welcomeMessageEnabled = false
  @observable accessor welcomeMessageText = ''

  readonly validation = validationContext(this, {})

  /**
   * Turns the welcome message on or off.
   */
  @action.bound
  setWelcomeMessageEnabled(value: boolean) {
    this.welcomeMessageEnabled = value
  }

  /**
   * Keeps the current message when the document has no message config.
   */
  @action
  hydrate(config: MessageConfig | undefined) {
    if (!config) {
      return
    }
    this.welcomeMessageEnabled = !!config.welcomeMessage?.enabled
    this.welcomeMessageText = config.welcomeMessage?.text ?? ''
  }

  /** @inheritDoc */
  receiveErrors(descriptor: ErrorDescriptor) {
    const { categories: _, welcomeMessage, ...rest } = descriptor.inner ?? {}
    const welcomeMessageText = welcomeMessage?.inner?.text
    receiveErrors(this, {
      ...rest,
      ...(welcomeMessageText && { welcomeMessageText }),
    })
  }

  /** @inheritDoc */
  toJSON(): MessageConfig {
    return {
      welcomeMessage: {
        enabled: this.welcomeMessageEnabled,
        text: this.welcomeMessageText,
      },
    }
  }
}
